<template>
  <super-admin-layout>
    <v-container fluid>
      <v-row>
        
          <v-col v-if="isTabletOrDesktop" md="12"  class="text-right">
            <v-spacer></v-spacer>
            <v-btn color="primary" class="mr-2 mb-2" @click="updateLeadFrom" v-if="$globalConfig.APP_NAME == 'direct'">Change
              Lead From</v-btn>
            <v-btn v-if="!seeding" color="primary" class="mr-2 mb-2" @click="reseedCourse"
              :disabled="this.company.package_id > 1">Reseed Courses</v-btn>
            <v-btn v-else loading class="mr-2 mb-2" color="error"></v-btn>
            <v-btn color="primary" class="mr-2 mb-2" @click="reseedTest" v-if="$globalConfig.APP_NAME == 'direct'">Reseed
              Tests</v-btn>
            <v-btn color="primary" class="mr-2 mb-2" @click="updateUserState">Change User State</v-btn>
            <v-btn color="primary" class="mr-2 mb-2" @click="updateBanding" v-if="$globalConfig.APP_NAME !== 'senso'">Change
              Banding</v-btn>
            <v-btn color="primary" class="mr-2 mb-2" @click="extendTrialPeriod">Extend Trial Period</v-btn>
            <v-btn color="primary" class="mr-2 mb-2" @click="resetWelcomeEmail">Reset Welcome Email</v-btn>
          </v-col>
          
          <v-col v-else md="12" class="text-right">
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="primary" v-bind="attrs" v-on="on">
                  More
                  <v-icon right>mdi-menu-down</v-icon>
                </v-btn>
              </template>

              <v-list>
                <v-list-item @click.prevent="updateLeadFrom"  v-if="$globalConfig.APP_NAME == 'direct'">
                  <v-list-item-title>Change Lead From</v-list-item-title>
                </v-list-item>
                <v-list-item v-if="!seeding" @click="reseedCourse" :disabled="this.company.package_id > 1">
                  <v-list-item-title>Reseed Courses</v-list-item-title>
                </v-list-item>
                <v-list-item v-else loading> </v-list-item>
                <v-list-item @click="reseedTest" v-if="$globalConfig.APP_NAME == 'direct'">
                  <v-list-item-title>Reseed Tests</v-list-item-title>
                </v-list-item>
                <v-list-item @click="updateUserState">
                  <v-list-item-title>Change User State</v-list-item-title>
                </v-list-item>
                <v-list-item @click="updateBanding" v-if="$globalConfig.APP_NAME !== 'senso'">
                  <v-list-item-title>Change Banding</v-list-item-title>
                </v-list-item>
                <v-list-item @click="extendTrialPeriod">
                  <v-list-item-title>Extend Trial Period</v-list-item-title>
                </v-list-item>
                <v-list-item @click="resetWelcomeEmail">
                  <v-list-item-title>Reset Welcome Email</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-col>

           <trial-period-drawer :trial-period-drawer="trialPeriodDrawer"></trial-period-drawer>
            <user-state-drawer :user-state-drawer="userStateDrawer" :state="company.state"></user-state-drawer>

            <company-banding-drawer :company-banding-drawer="companyBandingDrawer"
              :banding="company.banding_description" :package="company.package"
              :courseNamesToSelect="company.available_courses" :key="componentKey" @reload="handleReload" />
            <lead-drawer :leads-drawer="leadDrawer" :lead_id="company.lead_id"
              v-if="$globalConfig.APP_NAME == 'direct'" />

      </v-row>
      <v-row>
        <v-col md="12">
          <v-card>
            <v-tabs v-model="tab" grow>
              <v-tab v-for="item in items" :key="item">
                {{ item }}
              </v-tab>
            </v-tabs>
            <v-tabs-items v-model="tab">
              <v-tab-item
                :transition="false"
                :reverse-transition="false"
                key="Details"
              >
                <v-card flat class="text-left p-0" v-if="this.company">
                  <Details :detail="this.company"/>
                </v-card>
              </v-tab-item>
              <v-tab-item
                :transition="false"
                :reverse-transition="false"
                key="Users"
              >
                <Users />
              </v-tab-item>
              <v-tab-item
                :transition="false"
                :reverse-transition="false"
                key="Courses"
              >
                <v-card flat class="text-left">
                  <Courses />
                </v-card>
              </v-tab-item>
              <v-tab-item
                :transition="false"
                :reverse-transition="false"
                key="Customization"
              >
                <v-card flat class="text-left">
                  <Customization />
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </super-admin-layout>
</template>

<script>
import SuperAdminLayout from '@/layouts/SuperAdmin';
import companyAPI from '@/api/company.js';
import Details from '@/components/superadmin/Details';
import Courses from '@/components/superadmin/Courses';
import Users from '@/components/superadmin/Users';
import testAPI from '@/api/test.js';
import TrialPeriodDrawer from '@/components/superadmin/TrialPeriodDrawer';
import UserStateDrawer from '@/components/superadmin/UserStateDrawer';
import CompanyBandingDrawer from '@/components/superadmin/CompanyBandingDrawer';
import courseAPI from '@/api/course.js';
import { EventBus } from '@/event-bus.js';
import LeadDrawer from '@/components/superadmin/LeadDrawer';
import Customization from '@/components/superadmin/Customization';

export default {
  name: 'SuperAdminCompanyDetails',
  components: {
    SuperAdminLayout,
    Details,
    Courses,
    Users,
    TrialPeriodDrawer,
    UserStateDrawer,
    CompanyBandingDrawer,
    LeadDrawer,
    Customization
  },
  data() {
    return {
      company: [],
      loading: false,
      seeding: false,
      statusChanging: false,
      tab: null,
      trialPeriodDrawer: null,
      userStateDrawer: null,
      companyBandingDrawer: null,
      items: ['Details', 'Users', 'Courses', 'Settings'],
      companyId: this.$route.params.id,
      confirmDelete: 'Are you sure you want to delete this company?',
      confirmReseed: 'Are you sure you want to reseed test for this company?',
      confirmState: 'Are you sure you want to change state for this company?',
      confirmReseedCourse:
        'Are you sure you want to reseed course for this company?',
      confirmChangeStatus:
        'Are you sure you wish to change status for this user?',
      params: '',
      successReseedCourseMessage: 'Course reseeded successfully',
      successReseedTestMessage: 'Test reseeded successfully',
      successUserStateMessage: "Company state successfully changed",
      successTrialPeriodMessage: "Trial period successfully updated",
      successCompanyBandingMessage: "Company banding successfully changed",
      leadDrawer: null,
      componentKey: 0, // Used to force reload of the component
    };
  },
  computed: {
    isTabletOrDesktop() {
      const width = this.$vuetify.breakpoint.width;
      return width > 1180;
    },
  },
  mounted() {
    this.getCompany();
    this.setEventBus();
  },
  beforeDestroy() {
    EventBus.$off('USER_STATE_UPDATED');
    EventBus.$off('TRIAL_PERIOD_STATE_UPDATED');
    EventBus.$off('COMPANY_BANDING_UPDATED');
  },
  methods: {
    getCompany() {
      this.loading = true;
      companyAPI.getCompanyById(this.companyId, this.params).then((resp) => {
        this.company = resp.data.data;
        this.loading = false;
      });
    },
    reseedTest() {
      this.$snotify.confirm(this.confirmReseed, {
        backdrop:0.3,                         
        buttons: [
          { text: 'Cancel', className: 'toast-cancel-button' },
          {
            text: 'Continue',
             className: 'toast-continue-button',
            action: (toast) => this.processReseedTest(toast, this.companyId),
          }         
        ],
      });
    },
    updateUserState() {
      this.trialPeriodDrawer = false;
      this.companyBandingDrawer = false;
      this.leadDrawer = false;
      this.userStateDrawer = !this.userStateDrawer;
    },
    processReseedTest(toast, id) {
      this.$snotify.remove(toast.id);
      this.loading = true;
      testAPI.reseedTest(id).then((resp) => {
        this.loading = false;
        this.$router.push('/super-admin/companies');
      });
    },
    extendTrialPeriod() {
      this.userStateDrawer = false;
      this.companyBandingDrawer = false;
      this.leadDrawer = false;
      this.trialPeriodDrawer = !this.trialPeriodDrawer;
    },
    reseedCourse() {
      this.$snotify.confirm(this.confirmReseedCourse, {
        backdrop:0.3,                         
        buttons: [
          { text: 'Cancel',className: 'toast-cancel-button' },
          {
            text: 'Continue',
            className: 'toast-continue-button',
            action: (toast) => this.processReseedCourse(toast, this.companyId),
          }          
        ],
      });
    },
    processReseedCourse(toast, id) {
      this.$snotify.remove(toast.id);
      this.seeding = true;
      courseAPI.reseedCourse(id).then((resp) => {
        this.seeding = false;
        this.$router.push('/super-admin/companies');
      });
    },
    resetWelcomeEmail() {
      this.loading = true;
      companyAPI.resetWelcomeEmail(this.companyId).then((resp) => {
        this.loading = false;
      });
    },
    setEventBus() {
      EventBus.$on('USERSTATE_DRAWER_STATE', (payload) => {
        this.userStateDrawer = payload;
      });
      EventBus.$on('TRIALPERIOD_DRAWER_STATE', (payload) => {
        this.trialPeriodDrawer = payload;
      });
      EventBus.$on("USER_STATE_UPDATED", (payload) => {
        this.$snotify.success(this.successUserStateMessage);
        setTimeout(() => {
                         this.$gf.removeBackdrop();
                    },300);
          this.getCompany();
      });      
      EventBus.$on("TRIAL_PERIOD_STATE_UPDATED", (payload) => {
        this.$snotify.success(this.successTrialPeriodMessage);
        setTimeout(() => {
                         this.$gf.removeBackdrop();
                    },300);
        this.getCompany();
      });
      EventBus.$on('COMPANYBANDING_DRAWER_STATE', (payload) => {
        this.companyBandingDrawer = payload;
      });
      EventBus.$on("COMPANY_BANDING_UPDATED", (isUpdated, message) => {
        if (isUpdated) {
          this.$snotify.success(this.successCompanyBandingMessage);
        } else {
          this.$snotify.error(message);
        }
        this.componentKey++;
        this.getCompany();
        setTimeout(() => {
          this.$gf.removeBackdrop();
        }, 300);          
      });
      EventBus.$on('LEAD_DRAWER_STATE', (payload) => {
        this.leadDrawer = payload;
      });
    },
    updateBanding() {
      this.trialPeriodDrawer = false;
      this.userStateDrawer = false;
      this.leadDrawer = false;
      this.companyBandingDrawer = !this.companyBandingDrawer;
    },
    updateLeadFrom() {
      this.trialPeriodDrawer = false;
      this.companyBandingDrawer = false;
      this.userStateDrawer = false;
      this.leadDrawer = !this.leadDrawer;
    },
    handleReload() {
      this.componentKey++; // ⬅️ Increment to reload component
    }
  },
};
</script>
